import React, { useEffect, useState }  from 'react';
import { useConsultaSaldoPage } from 'hooks/useConsultaSaldoPage';

import ConsultarSaldoMobile from 'pages/Credito/1-Consulta/consultaMobile/consultaMobile';
import ConsultarSaldoDesktop from 'pages/Credito/1-Consulta/consultaDesktop/consultaDesktop';

import { useArrayCard } from 'hooks/useArrayCard'
import { removeStorage } from 'functions/storageBase64'
import Loading from 'components/Loading'


export default function ConsultarSaldo() {


    const { validateCards, associatedCards, errorCode: errorCodeN , udCardsArray, setValidateCards} = useArrayCard()
    const {cardsService, setUdCard, errorCode: errorCodeT , isMobile } = useConsultaSaldoPage()
    const [ loading, setLoading ] = useState(true)

    //- Codigo de instana para track de pagina 
    useEffect(()=>{
        // window.ineum('page', 'Check Balance Credit-Page')
        // window.ineum('meta', 'portal', 'Credito')
    },[])

    useEffect(()=>{
        if(validateCards){
            setUdCard(true)
            //setLoading(false)
        }
    },[validateCards])

    const [load, setLoad] = useState()
    useEffect(()=>{
        setLoading(load)
    },[load])


    useEffect(()=>{
        setTimeout(function(){
            setLoading(false)
        }, 10000)
    },[])

    const [errorCode, setErrorCode ] = useState()
    useEffect(()=>{
        if(errorCodeT){
            setErrorCode(errorCodeT)
            setLoading(false)
        }else if(errorCodeN){
            setErrorCode(errorCodeN)
            setLoading(false)
        }
    },[errorCodeT, errorCodeN])

    removeStorage('pagoExpress')
    removeStorage('noInternetPayment')
    removeStorage('payCardRelation')
    removeStorage('payCodeSuccess')

    return (
        <>
            { loading && <Loading /> }
            {isMobile
                ? isMobile === 'desktop'
                    ? <ConsultarSaldoDesktop cardsService={cardsService} setUdCard={setUdCard} setLoad={setLoad} errorCode={errorCode} />
                    : <ConsultarSaldoMobile cardsService={cardsService} setUdCard={setUdCard} setLoad={setLoad} errorCode={errorCode}/>
                : null
            }
        </>
    )
}